import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=3d031536&scoped=true&"
import script from "./FAQ.vue?vue&type=script&lang=js&"
export * from "./FAQ.vue?vue&type=script&lang=js&"
import style0 from "./FAQ.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FAQ.vue?vue&type=style&index=1&id=3d031536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d031536",
  null
  
)

export default component.exports